import { GlBadge, GlTooltipDirective } from '@gitlab/ui';
import { issuableTypeText } from '~/issues/constants';
import { __, sprintf } from '~/locale';
export default {
    name: 'ArchivedBadge',
    components: {
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        issuableType: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        title () {
            return sprintf(__('This %{issuable} belongs to an archived project and is read-only.'), {
                issuable: issuableTypeText[this.issuableType] || this.issuableType || 'item'
            });
        }
    }
};
